import type React from 'react';
import { useUnopenedNotifications } from '../hooks/useUnopenedNotifications';

export function EnabledUnOpenedNotification({
  loggedInUserId,
  children,
  topics,
}: {
  loggedInUserId?: string;
  topics?: string[];
  children: (unopenedNotificationsCount?: number) => React.ReactElement<any>;
}) {
  return loggedInUserId ? (
    <UnOpenedNotification loggedInUserId={loggedInUserId} topics={topics}>
      {children}
    </UnOpenedNotification>
  ) : (
    children()
  );
}

const UnOpenedNotification = ({
  loggedInUserId,
  children,
  topics,
}: {
  loggedInUserId?: string;
  children: (unopenedNotificationsCount?: number) => React.ReactElement<any>;
  topics?: string[];
}) => {
  const { unopenedNotificationsCount } = useUnopenedNotifications({ loggedInUserId, topics });

  return children(unopenedNotificationsCount);
};
